import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import {
  FormGroup,
  ReactiveFormsModule,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { of } from 'rxjs';
import { map, catchError, finalize, take } from 'rxjs/operators';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { TableComponent } from '@app/shared/components/table/table.component';
import { TableColumn } from '@app/shared/components/table/table.component';
import { Pagination } from '@app/shared/model';
import { FilterItem } from '@app/features-modules/gestao-bolseiros/components/api/models';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Toast } from 'primeng/toast';
import { MessageService, MenuItem, ConfirmationService } from 'primeng/api';
import { SkeletonModule } from 'primeng/skeleton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { GrupoPermissoesService } from '../../api/services/grupo-permissoes.service';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-lista-perfil',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SearchBarComponent,
    ConfirmDialogModule,
    SelectModule,
    DataVoidComponent,
    DialogModule,
    InputTextModule,
    ButtonModule,
    ReactiveFormsModule,
    Toast,
    TableComponent,
    SkeletonModule,
  ],
  providers: [MessageService, ConfirmationService, GrupoPermissoesService],
  templateUrl: './lista-perfil.component.html',
  styleUrls: ['./lista-perfil.component.scss'],
})
export class ListaPerfilComponent implements OnInit {
  private router = inject(Router);
  private fb = inject(FormBuilder);
  private cdr = inject(ChangeDetectorRef);
  @Output() totalRecordsChange = new EventEmitter<number>();

  messageService = inject(MessageService);
  grupoPermissoesService = inject(GrupoPermissoesService);
  confirmationService = inject(ConfirmationService);

  showModalAddGroup = false;
  isLoading = false;
  isEditMode = false;
  showFilter = false;
  form!: FormGroup;
  formAddGroup!: FormGroup;
  pagination: Pagination<any> = new Pagination<any>().deserialize({
    data: [],
    totalRecords: 0,
    pageNumber: 1,
    pageSize: 10,
  });

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'nome',
      placeholder: 'Nome do grupo',
    },
    // {
    //   type: 'dropdown',
    //   controlName: 'gender',
    //   placeholder: 'Género',
    //   options: this.listageneros,
    //   optionLabel: 'designacao',
    //   optionValue: 'id',
    // },
  ];

  columns: TableColumn[] = [
    { field: 'nomeGrupo', header: 'Nome do Grupo' },
    {
      field: 'description',
      header: 'Descrição',
    },
  ];

  private readonly hiddenGroups = new Set<string>([
    'ADMIN_EMPRESA',
    'ADMIN_MIREMPET',
    'Acordo de Formação',
    'Auxilio de Formação',
    'Cursos',
    'Dashboard',
    'Empresa Gestora',
    'Estudantes',
    'Instituições de Ensino',
    'Profissionais',
    'Relatórios',
  ]);

  actions: MenuItem[] = [
    {
      label: 'Associar',
      icon: 'pi pi-link',
      command: ($event: any) =>
        this.router.navigate(
          ['/configuracoes/perfil/associar-permissoes', $event.item.data.id],
          { queryParams: { nome: $event.item.data.nomeGrupo } }
        ),
    },
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      command: ($event: any) => this.editGroup($event.item.data),
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      command: ($event: any) => this.deletegroup($event.item.data),
    },
  ];

  ngOnInit(): void {
    this.formAddGroup = this.fb.group({
      nomeGrupo: [null, Validators.required],
      descricao: [null],
    });

    this.form = this.fb.group({
      nome: [null],
    });
    this.getAllGroups();
  }

  createNewProfile() {
    this.showModalAddGroup = true;
  }

  getAllGroups(queryParams: any = {}) {
    this.isLoading = true;
    // this.cdr.markForCheck();

    this.grupoPermissoesService
      .list({
        ...queryParams,
        pageNumber: this.pagination.pageNumber ?? 1,
        pageSize: this.pagination.pageSize ?? 10,
        OrderBy: queryParams?.OrderBy || 'id desc',
      })
      .pipe(
        take(1),
        map((res) => this.buildPaginationFromResponse(res)),
        // tap((pagination) => {
        //   this.pagination = pagination;
        //   // this.cdr.markForCheck();
        // }),
        catchError((error) => {
          console.error('Erro ao buscar grupos:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao buscar grupos.',
          });
          return of(this.emptyPagination());
        }),
        finalize(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe();
  }

  /** Função pura: mapeia, filtra, ordena e devolve Pagination consistente */
  private buildPaginationFromResponse(res: any): any {
    const raw = Array.isArray(res?.data) ? res.data : [];
    const total = res.totalRecords;
    this.totalRecordsChange.emit(total);

    const mapped = raw
      .map((item: any) => ({
        id: item?.id,
        nomeGrupo: item?.name,
        description: item?.description,
      }))
      // .filter((g: any) => !!g?.nomeGrupo && !this.hiddenGroups.has(g.nomeGrupo))
      .sort((a: any, b: any) =>
        String(a.nomeGrupo).localeCompare(String(b.nomeGrupo), 'pt', {
          sensitivity: 'base',
        })
      );
    this.isLoading = false;
    this.pagination = new Pagination<any>().deserialize({
      ...res,
      data: mapped,
    });
    // return new Pagination<any>().deserialize({
    //   ...res,
    //   data: mapped,
    //   totalRecords: mapped.length,
    //   pageNumber: this.pagination.pageNumber ?? 1,
    //   pageSize: this.pagination.pageSize ?? 10,
    // });
  }

  resetForm() {
    this.formAddGroup.reset();
    this.isEditMode = false;
    this.showModalAddGroup = false;
  }

  /** Pagination vazio consistente (evita estados “estranhos”) */
  private emptyPagination(): Pagination<any> {
    return new Pagination<any>().deserialize({
      data: [],
      totalRecords: 0,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
    });
  }

  saveGroup() {
    if (this.formAddGroup.invalid) {
      this.formAddGroup.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Por favor, preencha o campo de nome corretamente.',
      });
      return;
    }

    this.isLoading = true;
    this.cdr.markForCheck();

    this.grupoPermissoesService
      .createGrupo(
        this.formAddGroup.get('nomeGrupo')?.value,
        this.formAddGroup.get('descricao')?.value
      )
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Grupo criado com sucesso',
          });
          this.showModalAddGroup = false;
          this.getAllGroups();
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Não foi possível criar o grupo.',
          });
        },
      });
  }

  groupID = '';

  editGroup(data: any) {
    this.isEditMode = true;
    this.showModalAddGroup = true;
    this.formAddGroup.patchValue({
      nomeGrupo: data?.nomeGrupo ?? null,
      descricao: data?.description ?? null,
    });
    this.groupID = data?.id ?? '';
  }

  updateGroup() {
    if (this.formAddGroup.invalid) {
      this.formAddGroup.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Por favor, preencha o campo de nome corretamente.',
      });
      return;
    }
    const name = this.formAddGroup.get('nomeGrupo')?.value;
    const id = this.groupID;
    this.isLoading = true;
    this.cdr.markForCheck();
    this.grupoPermissoesService
      .updateGroup(id, name, this.formAddGroup.get('descricao')?.value)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Grupo actualizado com sucesso',
          });
          this.showModalAddGroup = false;
          this.getAllGroups();
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Não foi possível actualizar o grupo.',
          });
        },
      });
  }

  deletegroup(data: any) {
    this.confirmationService.confirm({
      message: `Tem a certeza que deseja eliminar o grupo ${data.nomeGrupo}?`,
      accept: () => {
        this.grupoPermissoesService
          .deleteGroup(data.id)
          .pipe(
            finalize(() => {
              this.isLoading = false;
              this.cdr.markForCheck();
            })
          )
          .subscribe({
            next: () => {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Grupo eliminado com sucesso',
              });
              this.getAllGroups();
            },
            error: () => {
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Não foi possível eliminar o grupo.',
              });
            },
          });
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelado',
          detail: 'A eliminação do grupo foi cancelada.',
        });
      },
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllGroups();
  }

  cancel() {
    if (this.isLoading) return;
    this.showModalAddGroup = false;
    this.isEditMode = false;
    this.formAddGroup.reset();
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    );
    this.getAllGroups(filters);
    this.showFilter = false;
  }
}
